import { GenericItem, IMeta } from '@bees-web/core/types'
import { MouseEvent } from 'react'
import { BUTTON_CLICKED } from '../../constants'
import { HomeInteractive } from '../../interfaces'
import { ButtonClicked } from '../../typewriter'
import { prepareProduct } from './segment/prepareProduct'

export type TopDeals = {
  top_deals_interactive: {
    attributes: {
      requestCart: ({
        cartQuantity,
        meta,
        nextQuantity,
        sku,
        promotion,
      }) => Promise<void>
      cartItems: GenericItem
      trackQuantityInteraction: ({
        quantity,
        original_quantity,
        edit_method,
        screen_name,
      }) => void
    }
  }
  top_deals_deferred_load: {
    attributes: { onLoad: (args) => void }
  }
  top_deals_showall_button_clicked: {
    attributes: {
      onClick: (_e: MouseEvent<HTMLButtonElement>, meta: IMeta) => void
    }
  }
}
export const trackButtonClicked = ({
  button_label,
  button_name,
  referrer,
  screen_name,
  url,
  recommendation_type,
  store_id,
  value_stream,
}: ButtonClicked) => ({
  type: BUTTON_CLICKED,
  payload: {
    button_label,
    button_name,
    referrer,
    screen_name,
    url,
    recommendation_type,
    store_id,
    value_stream,
  },
})

export interface ITrackQuantityInteraction {
  screen_name?: string
  edit_method?: string
  original_quantity?: number
  quantity?: number
}

export const topDeals: HomeInteractive<TopDeals> = (
  dispatch,
  interactiveState,
  globalActions
) => ({
  top_deals_interactive: {
    attributes: {
      requestCart: async ({
        nextQuantity,
        sku,
        promotion,
        meta,
        cartQuantity,
      }) => {
        const { referrer } = interactiveState.globals.page
        const screen_name = interactiveState.globals.page.name
        const cart_id = interactiveState.globals.cart.selectedCartId
        const viewType = 'Cases'
        const segmentProductDetails = {
          ...meta,
          ...prepareProduct({
            meta,
            qty: nextQuantity,
            promotion,
            viewType,
          }),
          index: null,
          original_quantity: cartQuantity,
          promotion,
          referrer,
          sku,
          screen_name,
          url: window.location.href,
          viewType,
          is_suggested: true,
          queryID: meta.searchQueryId || null,
          store_id: meta?.storeId || null,
          vendor_deal_id: promotion?.vendorDealId || null,
          vendorId: promotion?.vendorId || null,
          filter_categories_applied: null,
          cart_id,
        }
        if (cartQuantity === 0) {
          dispatch(
            globalActions.cart.trackProductAdded({
              ...meta,
              ...prepareProduct({
                meta,
                qty: nextQuantity,
                promotion,
                viewType,
              }),
              ...segmentProductDetails,
              add_method: 'Add Button',
            })
          )
        } else if (nextQuantity === 0) {
          dispatch(
            globalActions.cart.trackProductRemoved({
              ...segmentProductDetails,
              remove_method: 'Remove Button',
            })
          )
        } else {
          dispatch(
            globalActions.cart.trackProductQuantityEdited(segmentProductDetails)
          )
        }

        return dispatch(
          globalActions.cart.addToCart({
            items: [
              {
                id: sku,
                sku: sku,
                quantity: nextQuantity,
                deal_description:
                  promotion?.description ||
                  promotion?.details ||
                  promotion?.section ||
                  null,
                deal_id: promotion?.discountId || null,
                vendor_deal_id: promotion?.vendorDealId || null,
                deal_name: promotion?.title || null,
                promotion_type:
                  promotion?.type || promotion?.discountType || null,
                adj_base_price: 0,
                is_suggested: '',
                recommendation_id: '',
                recommendation_type: 'TOP_DEALS',
                recommended_quantity: '',
              },
            ],
          })
        )
      },
      cartItems: interactiveState.globals.cart.items,
      trackQuantityInteraction: ({
        quantity,
        original_quantity,
        edit_method,
      }: ITrackQuantityInteraction) => {
        const page = interactiveState.globals['page']
        dispatch(
          globalActions.cart.trackQuantityInteraction({
            screen_name: page.name,
            quantity,
            original_quantity,
            edit_method,
          })
        )
      },
    },
  },
  top_deals_deferred_load: {
    attributes: {
      onLoad: async (args) => {
        const { products, storeId } = args
        const { name: screenName } = interactiveState.globals.page

        const dispatchTrackCardsViewed = []
        products.forEach((recommendation: {}, index: number) => {
          dispatchTrackCardsViewed.push(
            dispatch(
              globalActions.appActions.trackCardViewed({
                ...prepareProduct({
                  meta: recommendation,
                  qty: 0,
                  promotion: recommendation,
                  viewType: 'Cases',
                }),
                position: index + 1,
                card_category: 'Recommendation',
                card_style: 'Carousel',
                cards_quantity: products.length,
                days_left: null,
                fifo_range_color: null,
                is_default_recommendation: null,
                is_suggested: null,
                screen_name: screenName,
                store_id: storeId || null,
                tier_type: null,
              })
            )
          )
        })

        Promise.all(dispatchTrackCardsViewed)
      },
    },
  },
  top_deals_showall_button_clicked: {
    attributes: {
      onClick: async (_e: MouseEvent<HTMLButtonElement>, meta: IMeta) => {
        const { name, referrer } = interactiveState.globals.page
        dispatch(
          trackButtonClicked({
            button_name: 'Deals',
            button_label: meta.button_label ?? null,
            referrer,
            screen_name: name,
            url: window.location.href,
            recommendation_type: null,
            module_name: null,
            store_id: null,
            value_stream: null,
          })
        )
      },
    },
  },
})
